<template>
  <div class="live-dashboard vh-100 d-flex flex-column mt-n2">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="10"
        class="mb-2"
      >
        <v-select
          v-model="id_com_realty_project"
          :options="projects"
          label="title"
          :reduce="item => item.id"
          class="bg-white rounded"
          :clearable="false"
          @input="refreshDashboard"
        />
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-button
          variant="success"
          block
          :href="downloadFile.filename"
          :disabled="!downloadFile.filename"
        >
          <FeatherIcon icon="DownloadIcon" />
          Excel İndir
        </b-button>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card2
          title-text="Satış Adet / Toplam Adet"
          sub-title-text="Toplam"
          :value-data="dashboardData.counters.sales.saleCount | toNumber"
          :value2-data="dashboardData.counters.sales.totalCount | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="Adet"
          prefix2-text=""
          suffix2-text="Adet"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card2
          title-text="Keşif Brüt Maliyet"
          sub-title-text="Toplam"
          :value-data="dashboardData.counters.analysisAmount[0].amount | toNumber"
          :value2-data="dashboardData.counters.analysisAmount[1].amount | toNumber"
          color-class="success"
          prefix-text=""
          :suffix-text="dashboardData.counters.analysisAmount[0].symbol"
          prefix2-text=""
          :suffix2-text="dashboardData.counters.analysisAmount[1].symbol"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card2
          title-text="Ciro"
          sub-title-text="Toplam"
          :value-data="dashboardData.counters.turnoverAmount[0].amount | toNumber"
          :value2-data="dashboardData.counters.turnoverAmount[1].amount | toNumber"
          color-class="success"
          prefix-text=""
          :suffix-text="dashboardData.counters.turnoverAmount[0].symbol"
          prefix2-text=""
          :suffix2-text="dashboardData.counters.turnoverAmount[1].symbol"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card2
          title-text="Görüşme Satış Oranı"
          sub-title-text="Görüşme / Satış"
          :value-data="dashboardData.counters.interviews.interviewCount | toNumber"
          :value2-data="dashboardData.counters.interviews.saleRates | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="Adet"
          prefix2-text=""
          suffix2-text="%"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Temas Tiplerine Görüşmeler"
            card-sub-title="Son 30 Gün"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="meetInterviews"
          />
          <div
            v-if="loadings.meetInterviews"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <column-charts
              v-if="dashboardData.meetInterviews.series.length"
              :series-data="dashboardData.meetInterviews.series"
              :categories-data="dashboardData.meetInterviews.categories"
              :colors-data="dashboardData.meetInterviews.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Gayrimenkul Tiplerine Göre Görüşmeler"
            card-sub-title="Son 30 Gün"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="realtyTypeInterviews"
          />
          <div
            v-if="loadings.realtyTypeInterviews"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.realtyTypeInterviews.series.length"
              :series-data="dashboardData.realtyTypeInterviews.series"
              :labels-data="dashboardData.realtyTypeInterviews.categories"
              :colors-data="dashboardData.realtyTypeInterviews.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Temas Tipi Bazlı Durum Kodları"
            card-sub-title="Son 30 Gün"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="statusCodeInterviews"
          />
          <div
            v-if="loadings.statusCodeInterviews"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <stacked-vertical-bar-charts
              :series-data="dashboardData.statusCodeInterviews.series"
              :categories-data="dashboardData.statusCodeInterviews.categories"
              :colors-data="dashboardData.statusCodeInterviews.colors"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Genel Durum"
            card-sub-title=""
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="overviewTable"
          />
          <div
            v-if="loadings.overviewTable"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <overview-table
              :data-list="dashboardData.overviewTable.rows"
              :grand-totals="dashboardData.overviewTable.grandTotals"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <report-customizer
      :cache-info="cacheInfo"
      :refresh-data="refreshDashboard"
      :start-countdown="startCountdown"
    />
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import PreLoading from '@/layouts/components/Loading.vue'
import CounterCard2 from '@/views/Dashboard/Live/Components/CounterCard2.vue'
import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
import ColumnCharts from '@/views/Dashboard/Live/Charts/ColumnCharts.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import ReportCustomizer from '@/views/Dashboard/Live/Components/ReportCustomizer.vue'
import StackedVerticalBarCharts from '@/views/Dashboard/Live/RealtySalesDashboard/StackedVerticalBarCharts.vue'
import OverviewTable from '@/views/Dashboard/Live/RealtySalesDashboard/OverviewTable.vue'

export default {
  name: 'RealtySalesDashboard',
  components: {
    StackedVerticalBarCharts,
    BRow,
    BCol,
    BCard,
    BButton,
    vSelect,
    PieCharts,
    ColumnCharts,
    CounterCard2,
    PreLoading,
    CardCustomHeader,
    OverviewTable,
    ReportCustomizer,
  },
  data() {
    return {
      intervalId: null,
      id_com_realty_project: '8',
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveRealtySalesDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveRealtySalesDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveRealtySalesDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
    projects() {
      return this.$store.getters['liveRealtySalesDashboard/projects']
    },
    downloadFile() {
      return this.$store.getters['liveRealtySalesDashboard/downloadFile']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getProjects()
    this.getDashboard()
  },
  methods: {
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('projects')
      this.getData('counters')
      this.getData('meetInterviews')
      this.getData('realtyTypeInterviews')
      this.getData('statusCodeInterviews')
      this.getData('overviewTable')
      this.getData('downloadFile')
    },
    refreshDashboard() {
      this.$store.commit('liveRealtySalesDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('meetInterviews')
      this.refreshData('realtyTypeInterviews')
      this.refreshData('statusCodeInterviews')
      this.refreshData('overviewTable')
      this.refreshData('downloadFile')
    },
    getProjects() {
      this.$store.dispatch('liveRealtySalesDashboard/getData', { type: 'projects' })
        .then(response => response)
    },
    getData(type) {
      this.$store.dispatch('liveRealtySalesDashboard/getData', { type, id_com_realty_project: this.id_com_realty_project })
    },
    refreshData(type) {
      this.$store.dispatch('liveRealtySalesDashboard/refreshData', { type, id_com_realty_project: this.id_com_realty_project })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
